import Dialog from '@cobliteam/ui/components/Dialog';
import Icon from '@cobliteam/ui/icons';

const AlertFooter = () => {
  return (
    <>
      <div className='flex h-10 w-full items-center justify-between bg-primary-9 px-4 text-white'>
        <div className='flex gap-2 font-bold text-xs'>
          <Icon name='info' /> Esta versão é um protótipo em desenvolvimento.{' '}
        </div>

        <Dialog>
          <Dialog.Trigger asChild>
            <div className='flex items-center gap-4 px-2 text-xs'>
              <button type='button' className='flex gap-1 font-semibold text-[10px] hover:text-white hover:underline'>
                <Icon name='message-square-warning' size='xs' className='mt-0.5' /> Reportar problema ou sugerir melhorias?
              </button>
            </div>
          </Dialog.Trigger>
          <Dialog.Content size='lg' className='max-w-3xl p-0'>
            <Dialog.Header className='p-4 pb-0'>
              <Dialog.Title>Reportar problema ou sugerir melhorias</Dialog.Title>
            </Dialog.Header>
            <div className='h-[600px] w-full'>
              <iframe
                src='https://cobli.notion.site/ebd/17a682738c9c81c38a29c0d79d1b1e37'
                width='100%'
                height='100%'
                frameBorder='0'
                allowFullScreen
                title='Notion Knowledge Base'
              />
            </div>
          </Dialog.Content>
        </Dialog>
      </div>
    </>
  );
};

export default AlertFooter;
